import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  isPreview?: boolean;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  barn: {},
  hasHorses: {
    cursor: ({ isPreview }) => (isPreview ? "default" : "pointer"),
    "& $barnPath": {
      fill: "#6bc285"
    },
    "& $circle": {
      fill: "#f3f5ea",
      stroke: "#009444",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    "& $circleOutline": {
      fill: "#009444"
    }
  },
  circle: { fill: "#E6E6E5" },
  circleOutline: {
    fill: "transparent"
  },
  barnPath: {
    fill: "#d7d9d1"
  },
  cls2: {
    clipPath: "url(#clippath)"
  },
  st0: { fill: "none" },
  st1: { fill: "#F8F2E2" },
  st2: { fill: "#D7D9D1" },
  st3: { fill: theme.palette.common.white },
  st4: { fill: "#92D8F3" },
  st5: { fill: "#EAE9EB" },
  st6: { fill: "#F5E5CE" },
  st7: { fill: "#B6D4AC" },
  st8: { fill: "#D2C9AF" },
  st9: { fill: "#DCECC8" },
  st10: { fill: "#666666" },
  st11: { fill: "#D5D7D7" },
  st12: { fill: "#F2F2F2" },
  st13: { fill: "#010101" },
  st15: { fontFamily: "SuisseIntlMedium, SuisseIntlRegular", color: "#F8F2E2" },
  st16: { fontSize: 16 }
}));
